import { registerCondition } from 'core/forms';

const isTemplate = ({ model }) => ({
  condition: null,
  hasCondition: model.radioOptions === 'template',
  shouldHideField: model.radioOptions === 'template',
});

registerCondition('isTemplate', isTemplate);

export default isTemplate;
